const isCyAvailable = (cy) => cy && !cy.destroyed();

export const applyGraphSearchFilter = ({
  cy,
  searchTerm,
  fitPadding,
  animationPadding = 50,
  animationDuration = 500,
}) => {
  if (!isCyAvailable(cy)) return false;

  const normalizedSearchTerm = searchTerm.trim().toLowerCase();

  if (normalizedSearchTerm === '') {
    cy.elements().removeClass('filtered');

    const visibleElements = cy.elements().filter((element) => !element.hasClass('filtered'));
    if (visibleElements.length > 0) {
      cy.fit(visibleElements, fitPadding);
    }

    return true;
  }

  cy.elements().addClass('filtered');

  const matchingNodes = cy.nodes().filter((node) => {
    const label = String(node.data('label') || '').toLowerCase();
    const id = String(node.data('id') || '').toLowerCase();
    return label.includes(normalizedSearchTerm) || id.includes(normalizedSearchTerm);
  });

  matchingNodes.removeClass('filtered');
  matchingNodes.connectedEdges().removeClass('filtered');
  matchingNodes.neighborhood().removeClass('filtered');

  if (matchingNodes.length > 0) {
    cy.animate({
      fit: {
        eles: matchingNodes,
        padding: animationPadding,
      },
      duration: animationDuration,
    });
  }

  return true;
};

export const resetGraphSearchView = (cy, fitPadding) => {
  if (!isCyAvailable(cy)) return false;
  cy.elements().removeClass('filtered');
  cy.fit(cy.elements(), fitPadding);
  return true;
};
